import React from 'react';

/**
 * DataCard — richer business-data card used in list views (agents, agencies,
 * onboarding runs, requests). Structured slots:
 *
 *   <DataCard
 *     title="John Doe"
 *     subtitle="NPN 12345678 · KR Direct"
 *     status={<StatusBadge …/>}
 *     avatar={<Avatar …/>}
 *     onClick={…}
 *   >
 *     …body sections…
 *   </DataCard>
 *
 * Renders as a clickable, hoverable white surface with a subtle gold ring on
 * hover so the whole row feels alive but never busy.
 */
export const DataCard = React.forwardRef(function DataCard(
  { title, subtitle, status, avatar, onClick, children, className = '', testId, footer },
  ref,
) {
  const clickable = typeof onClick === 'function';
  const Wrapper = clickable ? 'button' : 'div';
  return (
    <Wrapper
      ref={ref}
      onClick={onClick}
      type={clickable ? 'button' : undefined}
      className={`kr-card group text-left w-full ${clickable ? 'cursor-pointer hover:border-[color:var(--kr-gold-500)] transition-colors' : ''} ${className}`}
      data-testid={testId}
    >
      <div className="p-5">
        <header className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0 flex-1">
            {avatar && <div className="flex-shrink-0">{avatar}</div>}
            <div className="min-w-0">
              {title && (
                <h3
                  className="font-heading font-semibold text-[15px] leading-tight truncate"
                  style={{ color: 'var(--kr-navy-900)' }}
                >
                  {title}
                </h3>
              )}
              {subtitle && (
                <div className="text-xs mt-0.5" style={{ color: 'var(--kr-muted)' }}>
                  {subtitle}
                </div>
              )}
            </div>
          </div>
          {status && <div className="flex-shrink-0">{status}</div>}
        </header>
        {children && <div className="mt-4">{children}</div>}
      </div>
      {footer && (
        <footer
          className="px-5 py-2.5 border-t text-xs"
          style={{ borderColor: 'var(--kr-border)', color: 'var(--kr-muted)' }}
        >
          {footer}
        </footer>
      )}
    </Wrapper>
  );
});

export default DataCard;
